import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import AuthLayout from '../../../components/auth/AuthLayout';
import { useSignup } from '../../../contexts/SignupContext';

const getDemoAadhaarDetails = (refId) => ({
  refId,
  name: 'Demo Aadhaar User',
  gender: 'Female',
  dob: '1990-01-01',
  address: '123 Demo Street, Demo City, Demo State',
});

const SignupAadhaarOtp = () => {
  const navigate = useNavigate();
  const { signupState, updateSignupState } = useSignup();
  const [otp, setOtp] = useState('');
  const [refId, setRefId] = useState(signupState.aadhaarRefId || '');
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (!signupState.aadhaarRefId && !signupState.aadhaarUploadUrls) {
      navigate('/signup/aadhaar', { replace: true });
    }
  }, [signupState.aadhaarRefId, signupState.aadhaarUploadUrls, navigate]);

  const handleSubmit = (event) => {
    event.preventDefault();

    if (otp.trim().length !== 6) {
      toast.error('Please enter the 6-digit OTP');
      return;
    }

    if (!refId.trim()) {
      toast.error('Reference ID is required');
      return;
    }

    setLoading(true);

    const expectedOtp = signupState.aadhaarOtp;

    if (!expectedOtp || otp.trim() !== expectedOtp) {
      toast.error('Invalid OTP. Please try again.');
      setLoading(false);
      return;
    }

    updateSignupState({
      aadhaarRefId: refId.trim(),
      aadhaarDetails: getDemoAadhaarDetails(refId.trim()),
    });

    toast.success('Aadhaar verified successfully');
    navigate('/signup/business');
    setLoading(false);
  };

  return (
    <AuthLayout
      title="Enter Aadhaar OTP"
      subtitle="Verify the OTP sent to your Aadhaar-linked mobile"
      onBack={() => navigate('/signup/aadhaar')}
    >
      <form onSubmit={handleSubmit}>
        <div className="form-group">
          <label className="form-label">OTP</label>
          <input
            type="tel"
            className="form-input"
            maxLength={6}
            value={otp}
            onChange={(event) => {
              const value = event.target.value.replace(/\D/g, '');
              setOtp(value);
            }}
            placeholder="Enter OTP"
            required
          />
        </div>
        <div className="form-group">
          <label className="form-label">Reference ID</label>
          <input
            type="text"
            className="form-input"
            value={refId}
            onChange={(event) => setRefId(event.target.value)}
            placeholder="Enter reference ID"
            required
          />
        </div>
        <button type="submit" className="signin-btn" disabled={loading}>
          {loading ? 'Verifying...' : 'Verify & Continue'}
        </button>
      </form>
    </AuthLayout>
  );
};

export default SignupAadhaarOtp;


